import {getCustomSEO} from '../seo';
import {stripHTML} from '../../string.helper';

/**
 * Tạo SEO cho trang danh sách chuyên khoa
 */
export function generateSpecialtyListSEO(departments, webUrl) {
    const specialtyListUrl = `${webUrl}/chuyen-khoa`;

    // Tạo title
    const seoTitle = 'Chuyên khoa | CTCP Tập đoàn Bệnh viện TNH';

    // Tạo description từ danh sách các khoa
    let seoDescription = '';
    if (departments && Array.isArray(departments) && departments.length > 0) {
        // Lấy tên các khoa chính (tối đa 5-6 khoa đầu)
        const mainDepartments = departments
            .slice(0, 6)
            .map(dept => dept.department_name?.replace('Khoa ', '') || dept.department_name)
            .filter(Boolean);

        const departmentNames = mainDepartments.join(', ');
        const totalCount = departments.length;

        seoDescription = `CTCP Tập đoàn Bệnh viện TNH với ${totalCount} chuyên khoa đa dạng: ${departmentNames}${totalCount > 6 ? ' và nhiều khoa khác' : ''}. Đội ngũ bác sĩ chuyên khoa giàu kinh nghiệm, trang thiết bị hiện đại. Đặt lịch khám ngay.`;
    } else {
        seoDescription =
            'Hệ thống chuyên khoa đa dạng tại CTCP Tập đoàn Bệnh viện TNH. Đội ngũ bác sĩ chuyên khoa giàu kinh nghiệm, trang thiết bị hiện đại. Đặt lịch khám, tư vấn sức khỏe tại CTCP Tập đoàn Bệnh viện TNH.';
    }

    // Giới hạn description
    if (seoDescription.length > 160) {
        seoDescription = seoDescription.substring(0, 157) + '...';
    }

    // Tạo keywords từ danh sách khoa
    const keywordsParts = [];
    if (departments && Array.isArray(departments)) {
        // Lấy tên các khoa chính (tối đa 10)
        departments.slice(0, 10).forEach(dept => {
            if (dept.department_name) {
                // Thêm cả tên đầy đủ và tên ngắn
                keywordsParts.push(dept.department_name);
                const shortName = dept.department_name.replace(/^Khoa\s+/i, '');
                if (shortName !== dept.department_name) {
                    keywordsParts.push(shortName);
                }
            }
        });
    }
    keywordsParts.push('Chuyên khoa', 'Khoa', 'TNH', 'Bệnh viện TNH', 'Khám chuyên khoa', 'Đặt lịch khám');
    const seoKeywords = keywordsParts.join(', ');

    // Xử lý image - lấy ảnh từ khoa đầu tiên hoặc dùng default
    let seoImage = '';
    if (departments && Array.isArray(departments) && departments.length > 0) {
        const firstDept = departments.find(dept => dept.image_url);
        if (firstDept?.image_url) {
            seoImage = firstDept.image_url;
            // Đảm bảo URL đầy đủ
            if (seoImage && !seoImage.startsWith('http://') && !seoImage.startsWith('https://')) {
                seoImage = seoImage.startsWith('/') ? `${webUrl}${seoImage}` : `${webUrl}/${seoImage}`;
            }
        }
    }

    return getCustomSEO(seoTitle, seoDescription, specialtyListUrl, seoKeywords, seoImage);
}

/**
 * Tạo SEO cho trang chi tiết chuyên khoa
 */
export function generateSpecialtySEO(department, slug, webUrl) {
    const specialtyUrl = `${webUrl}/${slug}`;

    const seoTitle = department?.department_name
        ? `${department.department_name} | CTCP Tập đoàn Bệnh viện TNH`
        : 'Chuyên khoa TNH';

    let seoDescription = '';
    if (department?.description) {
        seoDescription = stripHTML(department.description, 160);
    } else if (department?.short_description) {
        seoDescription = stripHTML(department.short_description, 160);
    }

    // Nếu description quá ngắn (< 120), mở rộng với thông tin bổ sung
    if (seoDescription && seoDescription.length < 120 && department?.department_name) {
        seoDescription = `${seoDescription} Khám và điều trị tại ${department.department_name}, CTCP Tập đoàn Bệnh viện TNH với đội ngũ bác sĩ chuyên khoa giàu kinh nghiệm, trang thiết bị hiện đại.`;
        if (seoDescription.length > 160) {
            seoDescription = seoDescription.substring(0, 157) + '...';
        }
    }

    if (!seoDescription && department?.department_name) {
        seoDescription = `Khám và điều trị tại ${department.department_name} - CTCP Tập đoàn Bệnh viện TNH. Đội ngũ bác sĩ chuyên khoa giàu kinh nghiệm, trang thiết bị y tế hiện đại. Đặt lịch khám ngay.`;
    } else if (!seoDescription) {
        seoDescription =
            'Thông tin chi tiết về chuyên khoa tại CTCP Tập đoàn Bệnh viện TNH. Khám và điều trị với đội ngũ bác sĩ giàu kinh nghiệm, trang thiết bị hiện đại.';
    }

    const keywordsParts = [];
    if (department?.department_name) keywordsParts.push(department.department_name);
    keywordsParts.push('Chuyên khoa', 'TNH', 'Bệnh viện', 'Y tế');
    const seoKeywords = keywordsParts.join(', ');

    // Xử lý image - có thể là array hoặc string
    let seoImage = '';
    if (department?.picture_url) {
        seoImage = Array.isArray(department.picture_url) ? department.picture_url[0] || '' : department.picture_url;
    }
    if (!seoImage && department?.image_url) {
        seoImage = Array.isArray(department.image_url) ? department.image_url[0] || '' : department.image_url;
    }

    return getCustomSEO(seoTitle, seoDescription, specialtyUrl, seoKeywords, seoImage);
}
